import { USER_TYPES } from 'shared_DEPRECATED/types/User';

import { useUserContext } from 'features/user/context';

export const useCoachSettingsEnabled = () => {
  const { user } = useUserContext();

  return user?.type === USER_TYPES.USER;
};
